<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
  >
    <div class="content">
      <el-form
        ref="modify"
        :rules="rules"
        v-loading="isLoading"
        label-position="right"
        :model="formData"
        class="payment-system__form"
      >
        <el-form-item label="支付系统:">
          <el-input
            :disabled="true"
            v-model="formData.sysName"
            placeholder="必选"
            style="width: 440px;"
          ></el-input>
          <el-button v-if="formType !== 'edit'" @click="$_selectSys" class="select__btn">选择</el-button>
        </el-form-item>

        <el-form-item label="支付系统应用:" prop="sysAppName">
          <el-input
            v-model="formData.sysAppName"
            :disabled="formType === 'edit'"
            placeholder="必填"
            style="width: 440px;"
          ></el-input>
          <div class="input-tips" v-if="formType !== 'edit'">*仅支持16个中文字符或32个英文字符,并只包含.。，,()（）【】[]、\_-— 以上字符</div>
        </el-form-item>

        <el-form-item label="授权URL:" prop="authUrl">
          <el-input v-model="formData.authUrl" placeholder="选填，跳转授权的url地址" style="width: 440px;"></el-input>
        </el-form-item>

        <div v-if="formData.isSysConfig">
          <el-form-item label="系统级参数:"></el-form-item>
          <el-form-item
            v-for="item in configInfos[formData.sysType]"
            :key="item.key"
            :label="item.name + ':'"
            :required="item.required"
          >
            <el-input v-model.trim="item.value" style="width: 440px;" :placeholder="item.required ? '必填' : '非必填'"></el-input>
            <div class="input-tip">{{item.memo}}</div>
          </el-form-item>
          <el-form-item
            label="数字证书:"
            v-if="formData.isdcRequired"
          >
            <div class="row">
              <label for="upload">
                <input
                  type="file"
                  @change="$_selectFile"
                  ref="fileInput"
                  name="upload"
                  id="upload"
                  accept=".p12, .pem"
                  style="display: none"
                  :disabled="isUploading"
                />
                <span
                  :class="{ 'is-disabled': isUploading }"
                  class="upload__btn"
                  >选择文件</span
                >
              </label>
              <span class="input-tips"
                >（点击上传文件，支持.p12或.pem格式，大小不得超过2M）</span
              >
            </div>
            <span class="fname" :title="formData.certificateName">
              {{ formData.certificateName }}
              <i
                class="btn-del"
                @click="$_delFile()"
                v-if="formData.certificateName"
              ></i>
            </span>
          </el-form-item>
        </div>

        <el-form-item label="备注:" prop="memo" type="textarea">
          <el-input
            type="textarea"
            v-model="formData.memo"
            style="width: 500px; height: 48px;"
            resize="none"
            placeholder="选填，50字符内"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">保存</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>
    <!-- 选择支付系统弹窗组件 -->
    <select-sys
      v-if="modal.show === true && modal.template === 'select-sys'"
      :title="modal.title"
      :selected="modal.data"
      :sysConfigRequired="true"
      @callback="$_callbackSys"
      @close="$_close"
    ></select-sys>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import SelectSys from "@/components/modal-select-payCompany";
import md5f from "js-md5-file";
import OSS from "ali-oss";

export default {
  name: "modal-modify-appconfigs",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    modalData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      formData: {
        sysType: "",
        sysName: "",
        sysAppName: "",
        authUrl: "",
        memo: "",
        sid: -1,
        isSysConfig: false,
        isdcRequired: false,
        certificateUrl: "",
        certificateName: "",
        filePath: ""
      },
      configInfos: {},
      uploadId: 0,
      isUploading: false,
      client: null,
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
      rules: {
        sysAppName: [
          { required: true, message: "请输入支付系统应用" },
          { validator: Utils.validName, trigger: "blur" }
        ],
        authUrl: [
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 200) {
                callback(new Error("最多200个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        memo: [
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 50) {
                callback(new Error("最多50个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    // 选择支付系统
    $_selectSys() {
      this.modal.data = {
        sysType: this.formData.sysType,
        sysName: this.formData.sysName
      };
      this.modal.title = "选择支付系统";
      this.modal.template = "select-sys";
      this.modal.show = true;
    },
    // 选择支付系统回调
    $_callbackSys(data) {
      let { sysType, sysName, sysConfigRequired, sysConfigFields,dcRequired } = data;
      this.formData.sysType = sysType;
      this.formData.sysName = sysName;
      this.formData.isSysConfig = sysConfigRequired;this.formData.isdcRequired = dcRequired;
      if (sysConfigRequired === true) {
        if (!this.configInfos.hasOwnProperty(sysType)) {
          let configs = [];
          sysConfigFields.forEach(item => {
            configs.push({
              required: item.required,
              name: item.name,
              memo: item.memo,
              value: ""
            });
          });
          this.$set(this.configInfos, sysType, configs);
        }
      }
    },
    // 关闭选择
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
    //清空已选文件
    $_clearSelectedFile() {
      this.$refs["fileInput"].value = "";
    },
    //上传文件
    async $_selectFile(event) {
      const self = this;
      const files = event.target.files;
      if (!files || files.length === 0) return false;
      const file = files[0];
      const filename = file.name;
      let fileType = filename.replace(/([^\.]+\.)+(\S+)/g, "$2");

      // 校验文件格式
      if (!~["p12", "pem"].indexOf(fileType)) {
        $MessageBox.alert({
          content: "不支持的文件格式!",
          onOk() {
            self.$_clearSelectedFile();
          }
        });
        return false;
      }
      // 校验文件大小
      let fileSize = file.size / 1024 / 1024;
      if (fileSize > 2) {
        $MessageBox.alert({
          content: "文件超过2M, 文件大小不能超过2MB!",
          onOk() {
            self.$_clearSelectedFile();
          }
        });
        return false;
      }
      // 获取上传OSS配置
      const account = await this.$service.url("getUploadAccount");
      if (account.status !== 1) {
        $MessageBox.alert({ content: "获取配置失败" });
        return false;
      }
      let {
        region,
        accessKeyId,
        accessKeySecret,
        bucket,
        path,
        tmpPath,
        innerRegion
      } = account.data;
      this.client = new OSS({
        region,
        accessKeyId,
        accessKeySecret,
        bucket,
        innerRegion
      });
      // 中断原有的上传任务
      if (this.uploadId && this.isUploading === true) {
        this.client.abortMultipartUpload(this.formData.filePath, this.uploadId);
      }

      this.isUploading = true;
      md5f(file, async (err, fname) => {
        const filePath = `/${path}/${tmpPath}/paas/${fname}.${fileType}`;
        this.formData.filePath = filePath;
        try {
          let result = await this.client.multipartUpload(filePath, file, {
            progress(p, checkpoint) {
              if (typeof checkpoint !== "undefined" && checkpoint.uploadId) {
                self.uploadId = checkpoint.uploadId;
              }
              if (p === 1) {
                $MessageBox.alert({ content: "上传成功" });
              }
            },
            headers: {
              "Content-Disposition": `attachment;filename=${encodeURI(
                filename
              )}`
            }
          });
          if (result.res.status === 200) {
            let url = result.res.requestUrls[0];
            if (typeof innerRegion !== "undefined" && innerRegion !== "") {
              url = url.replace(region, innerRegion);
            }
            (self.formData.certificateName = filename),
              (self.formData.certificateUrl = url.substring(
                0,
                url.lastIndexOf("?uploadId") === -1
                  ? url.length
                  : url.lastIndexOf("?uploadId")
              ));
          }
        } catch (e) {
          this.$_clearSelectedFile();
          if (e.name !== "cancel" && status !== 0) {
            $MessageBox.alert({ content: "上传失败" });
          }
        }
        this.isUploading = false;
      });
    },
    //上传文件
    $_delFile() {
      let self = this;
      $MessageBox.confirm({
        content: "确定删除" + self.formData.certificateName + "？",
        onOk() {
          self.formData.certificateName = "";
          self.formData.certificateUrl = "";
          self.$_clearSelectedFile()
        }
      });
    },
    $_submit() {
      if (this.formData.sysType === "") {
        $MessageBox.alert({ content: "请选择支付系统" });
        return false;
      }
      //校验authurl的校验
      if (this.formData.authUrl !== "") {
        const regUrl = /(http|https):\/\/([\w.]+\/?)\S*/;
        if (this.formData.authUrl && !regUrl.test(this.formData.authUrl)) {
          $MessageBox.alert({
            content: `授权URL需要有http://或https://`
          });
          return false;
        }
      }
      this.$refs["modify"].validate(valid => {
        if (valid) {
          let { sid, sysType, sysAppName, authUrl, memo,certificateUrl,
            certificateName,isdcRequired } = this.formData;

          let sysConfigMap = {};
          if (this.formData.isSysConfig === true) {
            for (const item of this.configInfos[sysType]) {
              if (item.required == true && item.value == "") {
                $MessageBox.alert({
                  content: `系统级参数 ${item.name} 不能为空, 请填写!`
                });
                return false;
              }
              Object.assign(sysConfigMap, { [item.name]: item.value });
            }
          }

          const self = this;
          self.isLoading = true;
          let action = "savePaySysConfig";

          let postData = {
            sysType,
            sysAppName,
            authUrl,
            sysConfigMap,
            memo
          };

          if(isdcRequired){
            Object.assign(postData, { certificateUrl,
            certificateName });
          }

          if (self.formType === "edit") {
            action = "updatePaySysConfig";
            Object.assign(postData, { sid });
          }

          self.$service.post(action, postData).then(result => {
            self.isLoading = false;
            if (result.$.checkResult(result, true)) {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  self.visible = false;
                  self.$emit("callback");
                }
              });
            }
          });
        }
      });
    },

    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  created() {
    if (this.formType === "edit") {
      let {
        sid,
        sysType,
        sysName,
        sysAppName,
        authUrl,
        sysConfigMap,
        sysConfigFields,
        memo,
        certificateUrl,
        certificateName,
        dcRequired
      } = this.modalData;
      if (
        typeof sysConfigFields !== "undefined" &&
        Object.keys(sysConfigFields).length > 0
      ) {
        this.formData.isSysConfig = true;
        let configs = [];
        sysConfigFields.forEach(key => {
          configs.push({
            required: key.required,
            name: key.name,
            memo: key.memo,
            value: sysConfigMap[key.name]
          });
        });
        this.$set(this.configInfos, sysType, configs);
      }
      this.formData.sid = sid;
      this.formData.sysType = sysType;
      this.formData.sysName = sysName;
      this.formData.sysAppName = sysAppName;
      this.formData.authUrl = authUrl;
      this.formData.memo = memo;
      this.formData.isdcRequired = dcRequired;
      this.formData.certificateUrl = certificateUrl;
      this.formData.certificateName = certificateName;
    }
  },
  mounted() {
    this.visible = true;
  },
  components: {
    SelectSys
  }
};
</script>

<style lang="scss" scoped>
.payment-system__form {
  padding: {
    left: 20px;
  }
}
.upload__btn {
  display: inline-block;
  background-color: #1895dd;
  width: 80px;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  color: #fff;
  border: 0;
  &:hover {
    background-color: #36a9ec;
  }
  &:focus {
    background-color: #0581c9;
  }
  &.is-disabled {
    cursor: not-allowed;
  }
}
.fname {
  margin-top: 10px;
  display: flex;
  width: 500px;
  line-height: 28px;
  background: #e5e5e5;
  padding-left: 10px;
  position: relative;
  .btn-del {
    position: absolute;
    right: 0px;
    display: inline-block;
    width: 28px;
    height: 28px;
    cursor: pointer;
    background: url(~@/assets/images/icon-delete.png) no-repeat center;
    &:hover {
      background: url(~@/assets/images/icon-delete__hover.png) no-repeat center;
    }
  }
}
.content {
  padding: 20px 20px;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
}
.select__btn {
  margin-left: 8px;
}
.type__chk {
  margin: {
    top: 5px;
    right: 64px;
  }
}
/deep/.el-form-item.is-required .el-form-item__label::before {
  margin-right: 3px;
}
.input-tips {
  margin-left: 10px;
  position: absolute;
  display: inline-block;
}
.input-tip{
  color: #aaa;
}
/deep/ .el-form-item[type="textarea"] .el-form-item__error {
  top: 48px;
}
</style>


